import React from "react";
import { useNavigate } from "react-router-dom";
import "./PageNotFound.scss";

export default function PageNotFoundChild() {
  const navigate = useNavigate();

  const onBackNavigationHandler = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/hms/myAccount");
    }
  };

  return (
    <div className="page-not-found">
      <div className="page-not-found__illustration">
        <img src="/Images/pagenotfound.png" alt="Page not found" />
      </div>
      <h4 className="page-not-found__title">Oops! Page not found!</h4>
      <p className="page-not-found__subtitle">
        We can&apos;t seem to find the page you&apos;re looking for
        <br />
        Try going back to the previous page.
      </p>
      <button
        type="button"
        className="create-btn cursor-pointer"
        onClick={onBackNavigationHandler}
      >
        Back
      </button>
    </div>
  );
}
